/* Moood Devis Mode v2 - moood.fr <-> outils.moood.fr
 * Brief Devis V3.8 (20260517) - aligne sur pattern wishlist pur
 *
 * Mode dédié à l'ajout de produits dans un devis admin depuis le
 * catalogue moood.fr. Co-existe avec moood-wishlist-mode.js mais
 * désactive automatiquement le mode wishlist au démarrage.
 *
 * URL trigger : ?devis_mode=1&devis_id=<id>&t=<jwt>
 *
 * Endpoints cibles :
 *   POST /api/public/devis/<id>/lines/add-from-shopify   (ajout)
 *   GET  /api/public/devis/<id>/lines                    (aperçu)
 *   Headers: { Authorization: Bearer <jwt> }
 *
 * UI :
 *   - Banner vert ink #12433D en haut
 *   - Compteur "X ligne(s) ajoutée(s)"
 *   - Bouton "Aperçu" → drawer à droite avec les lignes
 *   - Bouton "Retour au devis" → window.close()
 *   - Bouton "Quitter le mode" → reset localStorage + reload
 *
 * Extraction properties : reprend EXACTEMENT le mécanisme de
 * moood-wishlist-mode.js (extractPropertiesFromForm /
 * extractPropertiesFromPayload + filterAndExtractPrice +
 * HIDDEN_PROPS). Pas de scraping DOM custom. Si modifs ici, mettre
 * à jour moood-wishlist-mode.js en miroir.
 */
(function() {
  'use strict';

  const API_BASE = 'https://outils.moood.fr/api/public/devis';
  const API_ADD_BASE = API_BASE; // backward-compat avec v1
  const ERP_URL = 'https://outils.moood.fr/dashboard/devis';

  const STORAGE = {
    TOKEN: 'moood_devis_token',
    DEVIS_ID: 'moood_devis_id',
    ACTIVE: 'moood_devis_active',
    SESSION_LINES: 'moood_devis_session_lines',
  };

  const COLORS = {
    primary: '#12433D',
    primaryDark: '#0d332e',
    accent: '#DFAE3A',
    error: '#dc2626',
    success: '#16a34a',
  };

  const NATIVE_FETCH = window.fetch.bind(window);

  let state = {
    sessionLines: 0,
    devisId: null,
  };

  function plural(n, w) { return n > 1 ? w + 's' : w; }

  function addMooodCustomProps(props) {
    if (window.mooOuvertureSelectionnee) {
      props["Sens d'ouverture"] = window.mooOuvertureSelectionnee;
    }
  }

  const HIDDEN_PROPS = new Set([
    'Tranche', 'Configuration', 'Label',
    'Largeur (mm)', 'Longueur (mm)', 'Surface (m²)',
    'Prix total (€)', 'Prix calculé (€)',
    'Supplément options (€)', 'Tarif appliqué (€/m²)',
  ]);

  function filterAndExtractPrice(rawProps) {
    const cleanProps = {};
    let customPrice = null;
    for (const [k, v] of Object.entries(rawProps || {})) {
      if (k === '__ooCustomPrice') {
        const p = parseFloat(String(v).replace(',', '.'));
        if (!isNaN(p) && p > 0) customPrice = p;
        continue;
      }
      if (k === 'Prix total (€)' && customPrice === null) {
        const p = parseFloat(String(v).replace(',', '.'));
        if (!isNaN(p) && p > 0) customPrice = p;
        continue;
      }
      if (k.startsWith('_')) continue;
      if (/^field_\d+$/.test(k)) continue;
      if (HIDDEN_PROPS.has(k)) continue;
      cleanProps[k] = v;
    }
    return { properties: cleanProps, customPrice };
  }

  function extractPropertiesFromForm(form) {
    const props = {};
    form.querySelectorAll('[name^="properties["]').forEach(input => {
      const m = input.name.match(/properties\[(.+?)\]/);
      if (m && input.value) props[m[1]] = input.value;
    });
    addMooodCustomProps(props);
    return props;
  }

  function extractPropertiesFromPayload(payload) {
    if (!payload) return {};
    const props = {};
    if (payload.properties && typeof payload.properties === 'object') {
      Object.assign(props, payload.properties);
    }
    for (const [k, v] of Object.entries(payload)) {
      const m = k.match(/^properties\[(.+?)\]$/);
      if (m && v) props[m[1]] = v;
    }
    addMooodCustomProps(props);
    return props;
  }

  function detectModeFromUrl() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('devis_mode') !== '1') return false;
    const devisId = params.get('devis_id');
    const token = params.get('t');
    if (!devisId || !token) return false;

    // Activer mode devis
    localStorage.setItem(STORAGE.TOKEN, token);
    localStorage.setItem(STORAGE.DEVIS_ID, devisId);
    localStorage.setItem(STORAGE.ACTIVE, '1');
    localStorage.setItem(STORAGE.SESSION_LINES, '0');

    // CRITIQUE : désactiver mode wishlist pour éviter double interception
    ['moood_wl_token', 'moood_wl_active', 'moood_wl_initial_items',
     'moood_wl_initial_amount', 'moood_wl_session_items',
     'moood_wl_session_amount', 'moood_wl_transfer_pending'
    ].forEach(k => localStorage.removeItem(k));

    // Cleanup URL
    params.delete('devis_mode');
    params.delete('devis_id');
    params.delete('t');
    const s = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (s ? '?' + s : '') + window.location.hash);
    return true;
  }

  function loadState() {
    state.sessionLines = parseInt(localStorage.getItem(STORAGE.SESSION_LINES) || '0', 10);
    state.devisId = localStorage.getItem(STORAGE.DEVIS_ID);
  }

  function saveState() {
    localStorage.setItem(STORAGE.SESSION_LINES, String(state.sessionLines));
  }

  function injectStyles() {
    if (document.getElementById('moood-devis-styles')) return;
    const style = document.createElement('style');
    style.id = 'moood-devis-styles';
    style.textContent = `
      body.moood-devis-mode { padding-top: 60px !important; }
      #moood-devis-banner {
        position: fixed; top: 0; left: 0; right: 0; z-index: 99999;
        background: ${COLORS.primary}; color: #fff;
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
        box-shadow: 0 2px 12px rgba(0,0,0,0.2);
      }
      #moood-devis-banner .inner {
        max-width: 1400px; margin: 0 auto; padding: 10px 16px;
        display: flex; align-items: center; justify-content: space-between;
        gap: 16px; flex-wrap: wrap;
      }
      #moood-devis-banner .info { display: flex; flex-direction: column; gap: 2px; flex: 1; min-width: 240px; }
      #moood-devis-banner .info .title { font-weight: 700; font-size: 14px; }
      #moood-devis-banner .info .stats { font-size: 13px; opacity: 0.95; }
      #moood-devis-banner .info .stats strong { color: ${COLORS.accent}; font-weight: 700; }
      #moood-devis-banner .actions { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
      #moood-devis-banner button {
        background: #fff; color: ${COLORS.primary};
        border: none; padding: 8px 14px; border-radius: 6px;
        font-size: 13px; font-weight: 600; cursor: pointer;
        transition: background 0.15s, transform 0.1s;
        font-family: inherit;
      }
      #moood-devis-banner button:hover { background: #f0f0f0; }
      #moood-devis-banner button:active { transform: scale(0.97); }
      #moood-devis-banner button.secondary {
        background: transparent; color: #fff;
        border: 1px solid rgba(255,255,255,0.4);
      }
      #moood-devis-banner button.secondary:hover { background: rgba(255,255,255,0.1); }

      #moood-devis-toast {
        position: fixed; bottom: 24px; right: 24px; z-index: 100000;
        background: ${COLORS.success}; color: #fff;
        padding: 14px 20px; border-radius: 8px;
        font-family: system-ui, sans-serif;
        font-size: 14px; font-weight: 600;
        box-shadow: 0 4px 16px rgba(0,0,0,0.2);
        transform: translateY(100px); opacity: 0;
        transition: all 0.3s ease;
        max-width: 380px;
      }
      #moood-devis-toast.show { transform: translateY(0); opacity: 1; }
      #moood-devis-toast.error { background: ${COLORS.error}; }

      /* V3.6 fix 2 : drawer Aperçu */
      #moood-devis-drawer-backdrop {
        position: fixed; inset: 0; z-index: 99998;
        background: rgba(0,0,0,0.4);
        opacity: 0; transition: opacity 0.2s ease;
        pointer-events: none;
      }
      #moood-devis-drawer-backdrop.show { opacity: 1; pointer-events: auto; }
      #moood-devis-drawer {
        position: fixed; top: 0; right: 0; bottom: 0; z-index: 99999;
        width: 420px; max-width: 92vw;
        background: #fff; color: #1a1a1a;
        box-shadow: -8px 0 24px rgba(0,0,0,0.18);
        transform: translateX(100%);
        transition: transform 0.25s ease;
        display: flex; flex-direction: column;
        font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
      }
      #moood-devis-drawer.show { transform: translateX(0); }
      #moood-devis-drawer .head {
        padding: 14px 18px; border-bottom: 1px solid #e5e7eb;
        background: ${COLORS.primary}; color: #fff;
        display: flex; justify-content: space-between; align-items: center;
      }
      #moood-devis-drawer .head .title { font-size: 14px; font-weight: 700; }
      #moood-devis-drawer .head .num { font-size: 11px; opacity: 0.85; font-weight: 600; letter-spacing: 0.05em; }
      #moood-devis-drawer .head .close {
        background: transparent; border: none; color: #fff;
        font-size: 22px; cursor: pointer; padding: 0 4px; line-height: 1;
      }
      #moood-devis-drawer .body { flex: 1; overflow-y: auto; padding: 4px 0; }
      #moood-devis-drawer .empty { padding: 32px 18px; text-align: center; color: #6b7280; font-size: 13px; }
      #moood-devis-drawer .loading { padding: 32px 18px; text-align: center; color: #6b7280; font-size: 13px; }
      #moood-devis-drawer .line {
        display: flex; gap: 10px; padding: 12px 18px;
        border-bottom: 1px solid #f3f4f6; align-items: flex-start;
      }
      #moood-devis-drawer .line:last-child { border-bottom: none; }
      #moood-devis-drawer .line img {
        width: 44px; height: 44px; object-fit: cover;
        border-radius: 4px; background: #f3f4f6; flex-shrink: 0;
        border: 1px solid #e5e7eb;
      }
      #moood-devis-drawer .line .placeholder {
        width: 44px; height: 44px; background: #f3f4f6;
        border-radius: 4px; flex-shrink: 0; border: 1px solid #e5e7eb;
      }
      #moood-devis-drawer .line .info { flex: 1; min-width: 0; }
      #moood-devis-drawer .line .name { font-size: 13px; font-weight: 600; line-height: 1.3; color: #1a1a1a; }
      #moood-devis-drawer .line .meta { font-size: 11.5px; color: #6b7280; margin-top: 2px; }
      #moood-devis-drawer .line .props { margin-top: 4px; font-size: 11px; line-height: 1.45; color: #6b7280; }
      #moood-devis-drawer .line .props .k { color: #4b5563; font-weight: 600; }
      #moood-devis-drawer .line .qty { font-size: 12px; font-weight: 700; color: ${COLORS.primary}; white-space: nowrap; margin-left: 4px; }
      #moood-devis-drawer .line.estimatif { background: #fff8ed; }
      #moood-devis-drawer .line.estimatif .estimation { color: #C4622A; font-weight: 600; font-style: italic; font-size: 11.5px; margin-top: 3px; }
      #moood-devis-drawer .foot {
        padding: 14px 18px; border-top: 1px solid #e5e7eb;
        background: #fafafa;
        display: flex; justify-content: space-between; align-items: center;
      }
      #moood-devis-drawer .foot .lbl { font-size: 12px; color: #6b7280; font-weight: 600; }
      #moood-devis-drawer .foot .val { font-size: 17px; font-weight: 800; color: ${COLORS.primary}; }

      @media (max-width: 720px) {
        body.moood-devis-mode { padding-top: 110px !important; }
        #moood-devis-banner .inner { flex-direction: column; align-items: stretch; padding: 10px 12px; gap: 8px; }
        #moood-devis-banner .info .stats { font-size: 12px; }
        #moood-devis-banner .actions { justify-content: space-between; width: 100%; }
        #moood-devis-banner button { flex: 1; padding: 8px 6px; font-size: 12px; }
      }
    `;
    document.head.appendChild(style);
  }

  function injectBanner() {
    if (document.getElementById('moood-devis-banner')) return;
    const banner = document.createElement('div');
    banner.id = 'moood-devis-banner';
    const devisLabel = state.devisId ? `#${state.devisId}` : '';
    banner.innerHTML = `
      <div class="inner">
        <div class="info">
          <div class="title">Mode devis ${devisLabel} actif</div>
          <div class="stats" id="moood-devis-stats">Aucune ligne ajoutée pour le moment</div>
        </div>
        <div class="actions">
          <button id="moood-devis-preview">Aperçu</button>
          <button id="moood-devis-back">Retour au devis</button>
          <button id="moood-devis-exit" class="secondary">Quitter le mode</button>
        </div>
      </div>
    `;
    document.body.insertBefore(banner, document.body.firstChild);
    document.body.classList.add('moood-devis-mode');
    document.getElementById('moood-devis-preview').addEventListener('click', openDrawer);
    document.getElementById('moood-devis-back').addEventListener('click', backToErp);
    document.getElementById('moood-devis-exit').addEventListener('click', exitMode);
  }


  // V3.6 fix 2 : drawer Aperçu - liste les lignes du devis en cours
  // via GET /api/public/devis/<id>/lines (Bearer JWT).
  function ensureDrawer() {
    if (document.getElementById('moood-devis-drawer')) return;
    const backdrop = document.createElement('div');
    backdrop.id = 'moood-devis-drawer-backdrop';
    backdrop.addEventListener('click', closeDrawer);
    document.body.appendChild(backdrop);

    const drawer = document.createElement('div');
    drawer.id = 'moood-devis-drawer';
    drawer.innerHTML = `
      <div class="head">
        <div>
          <div class="title">Aperçu du devis</div>
          <div class="num" id="moood-devis-drawer-num"></div>
        </div>
        <button class="close" type="button" aria-label="Fermer">×</button>
      </div>
      <div class="body" id="moood-devis-drawer-body">
        <div class="loading">Chargement…</div>
      </div>
      <div class="foot">
        <span class="lbl" id="moood-devis-drawer-count">—</span>
        <span class="val" id="moood-devis-drawer-total">—</span>
      </div>
    `;
    document.body.appendChild(drawer);
    drawer.querySelector('.close').addEventListener('click', closeDrawer);
  }

  async function openDrawer() {
    ensureDrawer();
    const drawer = document.getElementById('moood-devis-drawer');
    const backdrop = document.getElementById('moood-devis-drawer-backdrop');
    drawer.classList.add('show');
    backdrop.classList.add('show');
    await loadDrawerContent();
  }

  function closeDrawer() {
    const drawer = document.getElementById('moood-devis-drawer');
    const backdrop = document.getElementById('moood-devis-drawer-backdrop');
    if (drawer) drawer.classList.remove('show');
    if (backdrop) backdrop.classList.remove('show');
  }

  function eur(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })
      .format((Number(cents) || 0) / 100);
  }

  async function loadDrawerContent() {
    const token = localStorage.getItem(STORAGE.TOKEN);
    const devisId = localStorage.getItem(STORAGE.DEVIS_ID);
    const body = document.getElementById('moood-devis-drawer-body');
    const numEl = document.getElementById('moood-devis-drawer-num');
    const countEl = document.getElementById('moood-devis-drawer-count');
    const totalEl = document.getElementById('moood-devis-drawer-total');
    if (!body) return;
    body.innerHTML = '<div class="loading">Chargement…</div>';
    if (!token || !devisId) {
      body.innerHTML = '<div class="empty">Session devis absente.</div>';
      return;
    }
    try {
      const res = await NATIVE_FETCH(`${API_BASE}/${encodeURIComponent(devisId)}/lines`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const json = await res.json();
      if (!res.ok || !json.ok) {
        body.innerHTML = `<div class="empty">Erreur : ${(json && json.error) || 'inconnue'}</div>`;
        return;
      }
      if (numEl) numEl.textContent = json.devisNumber || '';
      const lines = json.lines || [];
      if (lines.length === 0) {
        body.innerHTML = '<div class="empty">Aucune ligne pour l\'instant. Ajoute des produits depuis le catalogue.</div>';
      } else {
        body.innerHTML = lines.map(renderDrawerLine).join('');
      }
      const validCount = lines.filter((l) => !l.is_estimatif).length;
      const estimCount = lines.length - validCount;
      const countTxt = validCount + ' ligne' + (validCount > 1 ? 's' : '')
        + (estimCount > 0 ? ' + ' + estimCount + ' estim.' : '');
      if (countEl) countEl.textContent = countTxt;
      if (totalEl) totalEl.textContent = eur(json.totalTtcCents);
    } catch (err) {
      console.error('[devis] drawer load error', err);
      body.innerHTML = '<div class="empty">Erreur réseau.</div>';
    }
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function renderDrawerLine(line) {
    const isEst = !!line.is_estimatif;
    const img = line.image_src
      ? `<img src="${escapeHtml(line.image_src)}" alt="">`
      : '<div class="placeholder"></div>';
    // Filtre _* et 'Estimatif total' deja resume (coherent PDF/admin UI)
    const propsEntries = line.properties && typeof line.properties === 'object'
      ? Object.entries(line.properties).filter(([k, v]) => {
          if (!k || typeof k !== 'string' || k.startsWith('_')) return false;
          if (k.trim().toLowerCase() === 'estimatif total') return false;
          return v != null && v !== '';
        })
      : [];
    const propsHtml = propsEntries.length > 0
      ? '<div class="props">' + propsEntries.map(([k, v]) =>
          `<div><span class="k">${escapeHtml(k)}</span> : ${escapeHtml(v)}</div>`
        ).join('') + '</div>'
      : '';
    // Estimatif : affiche 'Sur devis - estimation X' a la place du subtotal
    let estimationHtml = '';
    if (isEst) {
      const total = line.properties && line.properties['Estimatif total'];
      if (total) {
        estimationHtml = `<div class="estimation">Sur devis - estimation ${escapeHtml(total)}</div>`;
      } else {
        estimationHtml = '<div class="estimation">Sur devis - estimation à valider</div>';
      }
    }
    return `
      <div class="line${isEst ? ' estimatif' : ''}">
        ${isEst ? '' : img}
        <div class="info">
          <div class="name">${escapeHtml(line.title || 'Produit')}</div>
          ${line.variant_title ? `<div class="meta">${escapeHtml(line.variant_title)}</div>` : ''}
          ${propsHtml}
          ${estimationHtml}
        </div>
        ${isEst
          ? ''
          : `<div class="qty">× ${line.quantity || 1}<br><span style="font-weight:600;color:#6b7280;font-size:11px;">${eur(line.unit_price_cents)}</span></div>`}
      </div>
    `;
  }

  function updateBanner() {
    const stats = document.getElementById('moood-devis-stats');
    if (!stats) return;
    if (state.sessionLines === 0) {
      stats.textContent = 'Aucune ligne ajoutée pour le moment';
    } else {
      stats.innerHTML = `<strong>${state.sessionLines}</strong> ${plural(state.sessionLines, 'ligne')} ${plural(state.sessionLines, 'ajoutée')} au devis`;
    }
  }

  function showToast(message, type = 'success', duration = 2800) {
    const existing = document.getElementById('moood-devis-toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.id = 'moood-devis-toast';
    if (type === 'error') toast.classList.add('error');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => toast.remove(), 300);
    }, duration);
  }

  async function fetchProductData(variantId) {
    try {
      if (window.location.pathname.includes('/products/')) {
        const handle = window.location.pathname.split('/products/')[1].split(/[\/\?#]/)[0];
        if (handle) {
          const res = await NATIVE_FETCH(`/products/${handle}.js`);
          if (res.ok) {
            const product = await res.json();
            const variant = product.variants.find(v => String(v.id) === String(variantId));
            if (variant) {
              return {
                productId: product.id,
                title: product.title,
                variantTitle: variant.title === 'Default Title' ? null : variant.title,
                price: variant.price / 100,
                imageSrc: variant.featured_image?.src || product.featured_image,
                sku: variant.sku || null,
              };
            }
          }
        }
      }
    } catch (e) { console.warn('[devis] product fetch failed', e); }
    return { productId: 0, title: 'Produit moood', variantTitle: null, price: 0, imageSrc: null, sku: null };
  }

  async function sendToDevis({ variantId, quantity, properties = {} }) {
    const token = localStorage.getItem(STORAGE.TOKEN);
    const devisId = localStorage.getItem(STORAGE.DEVIS_ID);
    if (!token || !devisId) {
      showToast('Session devis absente. Reviens sur ton ERP.', 'error', 5000);
      return null;
    }
    const { properties: cleanProps, customPrice } = filterAndExtractPrice(properties);
    const data = await fetchProductData(variantId);
    const finalPrice = customPrice || data.price;

    // V3.6 DEBUG : log payload + properties resolves (a retirer une
    // fois stabilise). Permet de voir exactement ce qui est envoye
    // a l'API ERP.
    const bodyToSend = {
      variantId: parseInt(variantId, 10),
      productId: data.productId,
      title: data.title,
      variantTitle: data.variantTitle,
      sku: data.sku,
      price: finalPrice,
      imageSrc: data.imageSrc,
      quantity: parseInt(quantity, 10) || 1,
      properties: cleanProps,
    };
    console.log('[devis/DEBUG] sendToDevis', {
      handle: window.location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || null,
      variantId,
      rawProperties: properties,
      cleanProperties: cleanProps,
      customPrice,
      productData: data,
      bodySent: bodyToSend,
    });

    try {
      const res = await NATIVE_FETCH(`${API_ADD_BASE}/${encodeURIComponent(devisId)}/lines/add-from-shopify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(bodyToSend),
      });
      const json = await res.json();
      if (!res.ok || !json.ok) {
        if (res.status === 401) {
          showToast('Session devis expirée. Retour à l\'ERP.', 'error', 4000);
          setTimeout(backToErp, 2500);
          return null;
        }
        showToast(`Erreur : ${json.error || 'inconnue'}`, 'error');
        return null;
      }
      state.sessionLines += 1;
      saveState();
      updateBanner();
      showToast('Ligne ajoutée au devis', 'success');
      // V3.6 fix 2 : si le drawer Apercu est ouvert, refetch silencieux
      const drawer = document.getElementById('moood-devis-drawer');
      if (drawer && drawer.classList.contains('show')) {
        loadDrawerContent();
      }
      return json;
    } catch (err) {
      console.error('[devis] network error', err);
      showToast('Erreur réseau.', 'error');
      return null;
    }
  }

  function setupFormIntercept() {
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopPropagation();
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = form.querySelector('[name="quantity"]')?.value || 1;
      const properties = extractPropertiesFromForm(form);
      if (variantId) sendToDevis({ variantId, quantity, properties });
      else showToast('Variant introuvable sur ce produit', 'error');
    }, true);
  }

  function setupFetchIntercept() {
    window.fetch = function(input, init = {}) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.includes('/cart/add')) {
        let body = init.body;
        let payload = null;
        try {
          if (body instanceof FormData) {
            payload = {};
            for (const [k, v] of body.entries()) payload[k] = v;
          } else if (typeof body === 'string') {
            try { payload = JSON.parse(body); }
            catch {
              const p = new URLSearchParams(body);
              payload = {};
              for (const [k, v] of p.entries()) payload[k] = v;
            }
          } else if (body && typeof body === 'object') payload = body;
        } catch (e) {}
        if (payload && payload.id) {
          const properties = extractPropertiesFromPayload(payload);
          sendToDevis({ variantId: payload.id, quantity: payload.quantity || 1, properties });
          return Promise.resolve(new Response(
            JSON.stringify({ status: 'devis_added', items: [] }),
            { status: 200, headers: { 'Content-Type': 'application/json' } }
          ));
        }
      }
      return NATIVE_FETCH.apply(this, arguments);
    };
  }

  function setupXhrIntercept() {
    const OriginalXHR = window.XMLHttpRequest;
    function PatchedXHR() {
      const xhr = new OriginalXHR();
      let interceptUrl = '';
      const originalOpen = xhr.open;
      const originalSend = xhr.send;
      xhr.open = function(method, url) { interceptUrl = url || ''; return originalOpen.apply(this, arguments); };
      xhr.send = function(body) {
        if (typeof interceptUrl === 'string' && interceptUrl.includes('/cart/add')) {
          let payload = null;
          try {
            if (body instanceof FormData) {
              payload = {};
              for (const [k, v] of body.entries()) payload[k] = v;
            } else if (typeof body === 'string') {
              try { payload = JSON.parse(body); }
              catch {
                const p = new URLSearchParams(body);
                payload = {};
                for (const [k, v] of p.entries()) payload[k] = v;
              }
            }
          } catch (e) {}
          if (payload && payload.id) {
            const properties = extractPropertiesFromPayload(payload);
            sendToDevis({ variantId: payload.id, quantity: payload.quantity || 1, properties });
            Object.defineProperty(xhr, 'status', { value: 200, configurable: true });
            Object.defineProperty(xhr, 'responseText', { value: '{"status":"devis_added","items":[]}', configurable: true });
            setTimeout(() => {
              Object.defineProperty(xhr, 'readyState', { value: 4, configurable: true });
              if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange();
              if (typeof xhr.onload === 'function') xhr.onload();
            }, 50);
            return;
          }
        }
        return originalSend.apply(this, arguments);
      };
      return xhr;
    }
    window.XMLHttpRequest = PatchedXHR;
  }

  function relabelCartButtons() {
    const selectors = [
      'form[action*="/cart/add"] button[type="submit"]',
      'form[action*="/cart/add"] input[type="submit"]',
      'button[name="add"]',
      '.product_submit_button',
      '#moo-sm-atc',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(btn => {
      const currentText = btn.tagName === 'INPUT' ? btn.value : (btn.textContent || '').trim();
      if (currentText === 'Ajouter au devis') return;
      if (btn.dataset.mooodDevisRelabeled === '1') return;
      btn.dataset.mooodDevisRelabeled = '1';
      const isInput = btn.tagName === 'INPUT';
      if (isInput) {
        btn.value = 'Ajouter au devis';
      } else {
        let replaced = false;
        const walk = (node) => {
          if (replaced) return;
          for (const child of node.childNodes) {
            if (child.nodeType === 3 && child.textContent.trim()) {
              child.textContent = 'Ajouter au devis';
              replaced = true;
              return;
            } else if (child.nodeType === 1) walk(child);
          }
        };
        walk(btn);
        if (!replaced) btn.textContent = 'Ajouter au devis';
      }
      btn.style.setProperty('background', COLORS.primary, 'important');
      btn.style.setProperty('background-color', COLORS.primary, 'important');
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('border-color', COLORS.primary, 'important');
    });
  }

  let _observer = null;
  function startObserver() {
    if (_observer) return;
    _observer = new MutationObserver(() => relabelCartButtons());
    _observer.observe(document.body, { childList: true, subtree: true });
  }

  function backToErp() {
    if (window.opener) {
      try { window.close(); return; } catch (e) {}
    }
    // Fallback : redirect vers la page detail devis dans l'ERP
    if (state.devisId) {
      window.location.href = `${ERP_URL}/${state.devisId}`;
    } else {
      window.location.href = ERP_URL;
    }
  }

  function exitMode() {
    if (!confirm('Quitter le mode devis ?')) return;
    Object.values(STORAGE).forEach(k => localStorage.removeItem(k));
    window.location.reload();
  }

  function setupStorageSync() {
    window.addEventListener('storage', function(e) {
      if (!e.key || !e.key.startsWith('moood_devis_')) return;
      if (e.key === STORAGE.ACTIVE && e.newValue === null) {
        window.location.reload();
        return;
      }
      loadState();
      updateBanner();
    });
  }

  function init() {
    // Detection URL : si declenchee, on stocke + flush wishlist
    detectModeFromUrl();

    // Pas actif ? on quitte (le mode wishlist gere son cas)
    if (!localStorage.getItem(STORAGE.ACTIVE)) return;
    if (!localStorage.getItem(STORAGE.TOKEN)) return;

    loadState();
    injectStyles();
    injectBanner();
    updateBanner();
    setupFormIntercept();
    setupFetchIntercept();
    setupXhrIntercept();
    relabelCartButtons();
    startObserver();
    setupStorageSync();
    console.log('[Moood Devis] Mode actif v1 - devis=' + state.devisId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

